<template>
  <div class="mt-3">
    <h1>Формы</h1>

    <div class="mb-3 text-right">
      <router-link to="form/config/" class="btn btn-primary" style="margin-right:2px">
        Новая форма
      </router-link>
    </div>

    <table class="table table-hover">
      <thead>
        <tr>
          <th>Название формы</th>
          <th>Последняя версия</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="form in forms" :key="form.id">
          <td>{{ form.title }}</td>
          <td>{{ form.version }}</td>
          <td class="text-right">
            <b-button variant="primary" @click="show_from(form)" style="margin-right:2px">
              Заполнить
            </b-button>
            <router-link class="btn btn-primary" :to="'form/config/' + form.id" style="margin-right:2px; margin-left:2px">
              Изменить
            </router-link>
            <b-button variant="danger" @click="delete_form(form.id)" style="margin-left:2px">
              Удалить
            </b-button>
          </td>
        </tr>
        <tr v-if="isEmpty">
          <td colspan="3">Список форм пуст</td>
        </tr>
      </tbody>
    </table>

    <b-modal size="xl" ref="modal-show-form" title="Форма" hide-footer>
      <form-builder
        type="gui"
        :form="form_data"
        ref="FormBuilder"
      ></form-builder>
      <b-button variant="secondary" @click="$refs['modal-show-form'].hide()">
        Отмена
      </b-button>
      <b-button variant="primary" @click="save_record">Сохранить</b-button>
      <b-button variant="secondary" class="float-right" @click="printForm">Печать</b-button>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    forms: [],
    isEmpty: false,
    selected_form: 0,
    form_data: {}
  }),
  methods: {
    get_form_list() {
      var pageLoader = Vue.$loading.show();
      axios
        .get('/api/get_form_list')
        .then(response => {
          this.forms = response.data;
          this.isEmpty = _.isEmpty(this.forms);
        })
        .catch(error => {
          //console.log(error);
        })
        .finally(() => pageLoader.hide());
    },
    delete_form(form_id) {
      if (confirm('Вы уверены что хотите удалить форму?')) {
        var pageLoader = Vue.$loading.show();
        axios
          .delete('/api/delete_form/' + form_id)
          .then(response => {
            this.get_form_list();
            if (response.data.result) {
              SethPhatToaster.success(response.data.msg);
            } else {
              SethPhatToaster.error(response.data.msg);
            }
          })
          .catch(error => {
            //console.log(error);
          })
          .finally(() => pageLoader.hide());
      }
    },
    show_from(form) {
      var pageLoader = Vue.$loading.show();
      axios
        .get('/api/get_latest_form/' + form.id)
        .then(response => {
          this.selected_form = form.id;
          this.form_data = JSON.parse(response.data.form.data);
          this.$refs['modal-show-form'].show();
        })
        .catch(error => {
          //console.log(error);
        })
        .finally(() => pageLoader.hide());
    },
    save_record() {
      var pageLoader = Vue.$loading.show();
      axios
        .post('/api/create_record/' + this.selected_form, {
          values: JSON.stringify(this.$refs.FormBuilder.getValue())
        })
        .then(response => {
          if (response.data.result) {
            SethPhatToaster.success(response.data.msg);
            this.$refs['modal-show-form'].hide();
            this.selected_form = 0;
          } else {
            SethPhatToaster.error(response.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
          SethPhatToaster.error('Что-то пошло не так');
        })
        .finally(() => pageLoader.hide());
    },
    printForm() {
      var ifr = document.createElement('iframe');
      ifr.style='height: 0px; width: 0px; position: absolute';
      document.body.appendChild(ifr);
      console.log(this.$refs.FormBuilder);
      $(this.$refs.FormBuilder.$el).clone().appendTo(ifr.contentDocument.body);
      ifr.contentWindow.print();

      ifr.parentElement.removeChild(ifr);
    }
  },
  created() {
    this.get_form_list();
  }
};
</script>

<style scoped></style>
